import { Injectable } from '@angular/core';
import { AppCollection } from '../app.config';
import { BaseCollectionService } from '../core/jsonApi/BaseCollectionService';
import { SequenceJsonModel } from './sequence.json.model';

@Injectable({
  providedIn: 'root'
})
export class SequenceService extends BaseCollectionService<SequenceJsonModel, AppCollection> {
  protected ctor = SequenceJsonModel;
}
